import React from 'react'
import { TextField } from '@mui/material'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.sharedlib.entity.field.Field

export type EntityFormNumberDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormNumberDisplay = ({ field, fieldValue }: EntityFormNumberDisplayProps) => {
  const loading = fieldValue === undefined
  return (
    <TextField
      disabled
      required={field.required}
      label={field.name}
      value={fieldValue?.value ?? ''}
      placeholder={loading ? ' ' : undefined}
      InputLabelProps={loading ? { shrink: true } : undefined}
    />
  )
}

export default EntityFormNumberDisplay
